export const FETCH_USER = "fetch_user";



// WEBPACK FOOTER //
// ./src/actions/types.js